import { useMutation } from '@tanstack/vue-query'
import { postSliceyMessage } from './askSliceyEndpoints'

// Slicey chat is fire-and-forget per turn: each prompt is an independent POST.
// No cache invalidation, no key — the conversation history is client state
// (askSliceyStore). When the backend ships thread persistence we'll switch
// the history to a `useSliceyThreadQuery` and have this mutation invalidate it.
export function useSendSliceyMessageMutation() {
  return useMutation({ mutationFn: postSliceyMessage })
}
